var _path, _circle, _circle2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSmile = function SvgSmile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 12,
    viewBox: "0 0 42 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2514 7.6134C18.2514 8.86533 19.3439 9.95805 20.7904 9.95805C22.2369 9.95805 23.3293 8.86533 23.3293 7.6134H24.8579C24.8579 9.79549 22.9925 11.4866 20.7904 11.4866C18.5883 11.4866 16.7229 9.79549 16.7229 7.6134H18.2514Z",
    fill: "#0E3460"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 1.94307,
    transform: "matrix(-1 0 0 1 1.94304 2.17263)",
    fill: "#0E3460"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 1.94307,
    transform: "matrix(-1 0 0 1 39.6385 2.17263)",
    fill: "#0E3460"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/smile.a1fd0f4f.svg";
export { ForwardRef as ReactComponent };